export enum ImageUploadContext {
  Question,
  Answer,
  Explanation,
}

export enum ImageAddMethod {
  CopyPaste,
  DragDrop,
  Button,
}
